const KEY = 'holidayBadgingData';

export function getEventData() {
  const data = localStorage.getItem(KEY);
  // if the item doesn't exist, return null
  if (!data) {
    return null;
  }
  const eventData = JSON.parse(data);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > eventData.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(KEY);
    return null;
  }
  return eventData.value;
}

/**
 * @param {any} value
 */
export function setEventData(value) {
  const now = new Date();

  const item = {
    value,
    expiry: now.getTime() + 14400000, // 4Hour Expiry
  };
  localStorage.setItem(KEY, JSON.stringify(item));
}
